import {LoginComponent} from '../components/storefront/login/login.component';
import {DemoOnboardingComponent} from '../components/storefront/demo-onboarding/demo-onboarding.component';
import {HomeComponent} from '../components/storefront/home/home.component';
import {ErrorPageComponent} from '../components/storefront/error-page/error-page.component';
import {StorefrontComponent} from '../components/storefront/storefront.component';
import {AboutComponent} from '../components/storefront/about/about.component';
import {ContactComponent} from '../components/storefront/contact/contact.component';
import {PricingComponent} from '../components/storefront/pricing/pricing.component';
import {LoggedInRouteGuard} from '../helpers/route-guards/logged-in-route-guard';
import {NotLoggedInRouteGuard} from '../helpers/route-guards/not-logged-in-route-guard';
import {maintenanceRouteGuard} from '../helpers/route-guards/maintenance-route-guard';
import {MaintenanceComponent} from '../components/storefront/maintenance/maintenance.component';
import {QrDownloadAndLoginComponent} from '../components/storefront/qr-download-and-login/qr-download-and-login.component';

export const Routes = [
  {
    path: '',
    component: StorefrontComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
        data: {
          title: 'Bruiloft in je Broekzak'
        }
      },
      {
        path: 'error/:code',
        component: ErrorPageComponent
      },
      {
        path: 'maintenance',
        component: MaintenanceComponent,
        data: {
          title: 'Onderhoud | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'demo-onboarding',
        component: DemoOnboardingComponent,
        canActivate: [NotLoggedInRouteGuard, maintenanceRouteGuard],
        data: {
          title: 'Bruiloft aanmaken | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'about',
        component: AboutComponent,
        data: {
          title: 'Wie zijn wij | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'how-it-works',
        component: PricingComponent,
        data: {
          title: 'Hoe werkt het | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'contact',
        component: ContactComponent,
        data: {
          title: 'Contact | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [NotLoggedInRouteGuard, maintenanceRouteGuard],
        data: {
          title: 'Login | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'verify-email/:secret',
        loadComponent: () => import('../components/storefront/verify-email/verify-email.component').then(m => m.VerifyEmailComponent),
        canActivate: [NotLoggedInRouteGuard, maintenanceRouteGuard],
        data: {
          title: 'Email controleren | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'recover-account',
        loadComponent: () => import('../components/storefront/recover-account/recover-account.component').then(m => m.RecoverAccountComponent),
        canActivate: [NotLoggedInRouteGuard, maintenanceRouteGuard],
        data: {
          title: 'Account herstellen | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'recover-account/:secret',
        loadComponent: () => import('../components/storefront/recover-account/recover-account.component').then(m => m.RecoverAccountComponent),
        canActivate: [NotLoggedInRouteGuard, maintenanceRouteGuard],
        data: {
          title: 'Account herstellen | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'accept-invite/:invitationId/:secret',
        loadComponent: () => import('../components/storefront/accept-invite/accept-invite.component').then(m => m.AcceptInviteComponent),
        canActivate: [NotLoggedInRouteGuard, maintenanceRouteGuard],
        data: {
          title: 'Uitnodiging accepteren | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'static/privacy-policy-en',
        loadComponent: () => import('../components/storefront/static/privacy-policy-en/privacy-policy-en.component').then(m => m.PrivacyPolicyEnComponent),
        data: {
          title: 'Privacy Policy | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'static/privacy-policy-nl',
        loadComponent: () => import('../components/storefront/static/privacy-policy-nl/privacy-policy-nl.component').then(m => m.PrivacyPolicyNlComponent),
        data: {
          title: 'Privacy-beleid | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'static/end-user-agreement-en',
        loadComponent: () => import('../components/storefront/static/end-user-agreement-en/end-user-agreement-en.component').then(m => m.EndUserAgreementEnComponent),
        data: {
          title: 'End-user Agreement | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'static/end-user-agreement-nl',
        loadComponent: () => import('../components/storefront/static/end-user-agreement-nl/end-user-agreement-nl.component').then(m => m.EndUserAgreementNlComponent),
        data: {
          title: 'Gebruiksvoorwaarden | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'static/terms-conditions-en',
        loadComponent: () => import('../components/storefront/static/terms-conditions-en/terms-conditions-en.component').then(m => m.TermsConditionsEnComponent),
        data: {
          title: 'Terms and Conditions | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'static/terms-conditions-nl',
        loadComponent: () => import('../components/storefront/static/terms-conditions-nl/terms-conditions-nl.component').then(m => m.TermsConditionsNlComponent),
        data: {
          title: 'Algemene Voorwaarden | Bruiloft in je Broekzak'
        }
      },
      {
        path: 'download',
        component: QrDownloadAndLoginComponent,
        data: {
          title: 'Download Bruiloft in je Broekzak'
        }
      },
      {
        path: 'download/:secret',
        component: QrDownloadAndLoginComponent,
        data: {
          title: 'Download Bruiloft in je Broekzak'
        }
      }
    ]
  },
  {
    path: 'workshop',
    loadComponent: () => import('../components/workshop/workshop.component').then(m => m.WorkshopComponent),
    canActivate: [LoggedInRouteGuard, maintenanceRouteGuard],
    data: {
      title: 'Werkplaats | Bruiloft in je Broekzak'
    },
    children: [
      {
        path: 'confirm-upgrade',
        loadComponent: () => import('../components/workshop/confirm-upgrade/confirm-upgrade.component').then(m => m.ConfirmUpgradeComponent)
      },
      {
        path: 'event-list',
        loadComponent: () => import('../components/workshop/event-list/event-list.component').then(m => m.EventListComponent)
      },
      {
        path: 'event-list/invitation/:invitationId',
        loadComponent: () => import('../components/workshop/event-list/existing-user-invitation/existing-user-invitation.component').then(m => m.ExistingUserInvitationComponent)
      },
      {
        path: 'onboarding-wizard',
        loadComponent: () => import('../components/workshop/onboarding-wizard/onboarding-wizard.component').then(m => m.OnboardingWizardComponent)
      },
      {
        path: 'upgrade',
        loadComponent: () => import('../components/workshop/upgrade/upgrade.component').then(m => m.UpgradeComponent)
      },
      {
        path: 'workbench',
        loadComponent: () => import('../components/workshop/workbench/workbench.component').then(m => m.WorkbenchComponent)
      }
    ]
  },
  {
    path: 'slideshow/:secret',
    loadComponent: () => import('../components/slideshow/slideshow.component').then(m => m.SlideshowComponent),
    data: {
      title: 'Diavoorstelling | Bruiloft in je Broekzak'
    }
  },
  {
    path: '**',
    redirectTo: 'error/404'
  }
];
